import {
   PreInterviewExpiredFault,
   PreInterviewInitializationResult,
   PreInterviewInitializeCommand,
} from '@dreryk/egabinet-pre-interview-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../translations';
import { PreInterviewFormBean } from '../shared/form/PreInterviewForm.types';

type PreInterviewInitializeActionRenderProps = {
   initializePreInterview: (parameters: PreInterviewFormBean) => Promise<PreInterviewInitializationResult>;
};

type PreInterviewInitializeActionProps = {
   appointmentId: number;
   surveyTemplateVersionId: number;
   children: (renderProps: PreInterviewInitializeActionRenderProps) => JSX.Element;
   onSurveyInitialized: (surveyId: number) => void;
   onPreInterviewExpiredFault: VoidFunction;
};

export const PreInterviewInitializeAction = (props: PreInterviewInitializeActionProps): JSX.Element => {
   const { executeAsync: initializePreInterview } = useCqrsCommand<
      PreInterviewInitializationResult,
      PreInterviewFormBean,
      PreInterviewExpiredFault
   >(
      () => {
         const command = new PreInterviewInitializeCommand();
         command.appointmentId = props.appointmentId;
         command.surveyTemplateVersionId = props.surveyTemplateVersionId;
         return command;
      },
      {
         onSuccess: (result) => {
            props.onSurveyInitialized(result.surveyId);
         },
         onFault: {
            'egabinet-pre-interview-frontend-api:PreInterviewExpiredFault': () => {
               props.onPreInterviewExpiredFault();
               dispatchSnackbarNegativeEvent(
                  appointmentsTranslationKeys.preInterview.modal.create.form.errors.preInterviewExpiredFault
               );
            },
         },
      }
   );

   return props.children({
      initializePreInterview: initializePreInterview,
   });
};
